import { FC, useEffect, useState } from 'react';
import { useField } from 'formik';
import { FieldGroup, IFormProps } from '.';
import { RadioInput, EnumsType } from 'src/Components/Controls';
import EnumControlViewModel from '../Models/EnumControlViewModel';
import { SelectSimple } from '@redoc/ui-kit';
import { EnumLiteralType } from '../Types';

interface IEnumControlProps extends IFormProps {
	model: EnumControlViewModel;

	enumValue?: keyof EnumLiteralType;
	enumText?: keyof EnumLiteralType;
}

const EnumControl: FC<IEnumControlProps> = ({
	model,
	readOnly,
	setFieldValue,
	enumValue = 'LV',
	enumText = 'DA',
}) => {
	const [inputProps, , helperProps] = useField(model.FullPath);
	const [options, setOptions] = useState<EnumsType>([]);
	const isDisabled = readOnly || !model.ControlEnabling;

	//  подтягиваем только когда model.selectedValueS2 изменился извне
	useEffect(() => {
		const normalize = (
			value: string | string[] | null | undefined,
		): string[] | string | null => {
			return model.multiflag
				? Array.isArray(value)
					? value
					: value
						? [value]
						: []
				: (value ?? null);
		};

		const modelValue: string | string[] | null | undefined =
			model.selectedValueS2;

		// Если значение задано дефолтом, но его нет в доступных опциях, то очищаем (как в старом UI)
		if (modelValue != null && model.options?.length) {
			const inOptions = (v: string) => {
				return model.options.some((el) => {
					return String(el[enumValue]) === String(v);
				});
			};
			const values = Array.isArray(modelValue)
				? modelValue
				: [modelValue];
			if (!values.every(inOptions)) {
				model.setValue(null);
				model.selectedValueS2 = null;
				helperProps.setValue(null, false);
				return;
			}
		}

		const normalizedModelValue = normalize(modelValue);
		const normalizedFormValue = normalize(inputProps.value);
		const valuesAreEqual =
			JSON.stringify(normalizedModelValue) ===
			JSON.stringify(normalizedFormValue);
		if (!valuesAreEqual) {
			helperProps.setValue(normalizedModelValue, true);
		}
		// eslint-disable-next-line
	}, [model.selectedValueS2, model.multiflag]);

	useEffect(() => {
		const _opt =
			model.options?.map((el) => {
				return { id: el[enumValue], title: String(el[enumText]) };
			}) ?? [];
		setOptions(_opt);
		// eslint-disable-next-line
	}, [model.options]);

	const onSetFieldValue = (value: any) => {
		if (isDisabled) {
			return;
		}

		model.setValue(value);
		model.selectedValueS2 = value;
		model.Validate();
		setFieldValue(model.FullPath, value);
	};

	const renderInput = () => {
		if (model.ControlKey === 'RadioGroup') {
			return (
				<RadioInput
					name={model.FullPath}
					disabled={isDisabled}
					items={options}
					value={inputProps.value}
					isCol={false}
					noUnderLine
					onChangeValue={onSetFieldValue}
				/>
			);
		} else {
			return (
				<div style={{ width: '100%' }}>
					<SelectSimple
						name={model.FullPath}
						setValue={onSetFieldValue}
						placeholder={model.nullTitle}
						className={`${model.IsValid ? '' : 'st.error'}`}
						disabled={isDisabled}
						options={options}
						searchEnable={!isDisabled}
						multiple={model.multiflag}
						value={inputProps.value}

						isPortal={true}
					/>
				</div>
			);
		}
	};

	return (
		<FieldGroup
			hidden={!model.ControlVisibility}
			name={model.FullPath}
			isInvalid={!model.IsValid}
			errorMsg={model.errorMessage}
			title={model.Caption}
			width={model.Width ?? 12}
			isRequired={model.IsMandatory}
			readOnly={readOnly}
		>
			{renderInput()}
		</FieldGroup>
	);
};

export default EnumControl;
